// extracted by mini-css-extract-plugin
module.exports = {"squad":"Squad_squad__16WBv","imgWrapper":"Squad_imgWrapper__1HTSG"};